import { format } from "date-fns";

type DateInput = string | number | Date | null | undefined;

const toDate = (value: DateInput): Date | null => {
  if (value === null || value === undefined || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

// Standard user-facing date format across the app, e.g. "Apr 28 2026".
export const formatDisplayDate = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "MMM dd yyyy") : "";
};

// Short date without year, e.g. "Apr 28" (used for chart labels).
export const formatShortDate = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "MMM dd") : "";
};

// Standard date + time, e.g. "Apr 28 2026 09:41 AM" (last-sync labels).
export const formatDisplayDateTime = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "MMM dd yyyy hh:mm a") : "";
};

// Time of day only, e.g. "09:41 AM" (appointment banners: "{date} at {time}").
export const formatDisplayTime = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "hh:mm a") : "";
};

// Short weekday + day/month, e.g. "Mon 28/04" (chart tooltips).
export const formatWeekdayDayMonth = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "EEE dd/MM") : "";
};

// Full weekday + day/month, e.g. "Monday 28/04" (chart tooltips/legacy).
export const formatFullWeekdayDayMonth = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "EEEE dd/MM") : "";
};

// Full weekday + short date, e.g. "Monday, Apr 28" (dashboard day navigation).
export const formatFullWeekdayShortDate = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "EEEE, MMM dd") : "";
};

// Short weekday + short date, e.g. "Mon, Apr 28" (week range picker).
export const formatWeekdayShortDate = (value: DateInput): string => {
  const date = toDate(value);
  return date ? format(date, "EEE, MMM dd") : "";
};
